import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import {useTranslation} from "react-i18next";
import BaseUnifiedThreatPrevention from '../../AbstractObjects/GatewayPlan/InnerPages/BaseUnifiedThreatPrevention';
import {threatPreventionIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.unifiedThreatPrevention;
const pageId = pageSchema.pageId;

function GatewayUnifiedThreatPrevention({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId
}) {

    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.UNIFIED_THREAT_PREVENTION')}
            icon={threatPreventionIcon}
        >
            <BaseUnifiedThreatPrevention
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                setEditorPageId={setEditorPageId}
            />
        </LockToPlanContainer>
    );
}

export default GatewayUnifiedThreatPrevention;